// @flow
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { DEFAULT_MESSAGE } from 'esm-web-pro/redux/confirmations/constants';
import MessageDialog from 'esm-web-pro/components/dialogs/MessageDialog';

type Props = {
    message: string | null,
    onClose: Function,
    onProceed: Function,
};

const LeavePageDialog = (props: Props) => {
    const { message, onClose, onProceed } = props;
    return (
        <MessageDialog
            title={(
                <FormattedMessage id="leave-page-request" defaultMessage="Are you sure you want to continue?" />
            )}
            message={(
                message !== DEFAULT_MESSAGE
                    ? message
                    : null
            )}
            actions={{
                cancel: {
                    label: <FormattedMessage id="leave-page-request-cancel" defaultMessage="Cancel" />,
                    callback: () => onClose(false),
                    type: 'negative',
                },
                confirm: {
                    label: <FormattedMessage id="leave-page-request-proceed" defaultMessage="Proceed" />,
                    callback: () => onProceed(true),
                    type: 'positive',
                },
            }}
        />
    );
};

export default LeavePageDialog;
